import { render } from "./NeoHowItWorks.vue?vue&type=template&id=4f2db59f&scoped=true"
import script from "./NeoHowItWorks.vue?vue&type=script&lang=js"
export * from "./NeoHowItWorks.vue?vue&type=script&lang=js"

import "./NeoHowItWorks.vue?vue&type=style&index=0&id=4f2db59f&lang=scss&scoped=true"

import exportComponent from "/var/www/html/neo-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2db59f"]])

export default __exports__